import {Bars} from 'react-loader-spinner'
import axios from "axios";
import moment from "moment";
import React, {useContext, useEffect, useState} from "react";
import Chart from "../../Chart/Chart";
import {authContext} from "../../Context/Authentication/authContext";
import {generateMonthCount, mergeCompareData} from "../../util";
import "./DaysOnMarket.scss";
import {baseURL} from '../../config';
import {getAdjustedPredictionData, getAdjustedSentimentData, getAnticipatedPredictionData} from '../../Helpers/helpers'
import WChart from '../../WhatIfAnalysis/Chart/Chart';

const DaysOnMarket = () => {
  const {state}: any = useContext(authContext);
  const [chartData, setChartData]: any = useState(null);
  const [isAdjustedPrediction, setIsAdjustedPrediction]: any = useState(false);

  useEffect(() => {
    setChartData(null);
    if (state.filters.predictionsArray.length != 0) {
      setIsAdjustedPrediction(true);
      getAllPredictionData()
      // state.filters.predictionsArray.map((t: any) => {
      //   console.log(t);

      //   if (t == "Mortgage Rates") {
      //     if (
      //       state.filters.refreshAdjustedPredictionSubmit &&
      //       state.filters.zipcode?.length === 0
      //     ) {
      //       setIsAdjustedPrediction(true);
      //       getAdjustedPrediction();
      //     }
      //   } else if (t == "Consumer Sentiments(HPSI)") {
      //     if (
      //       state.filters.refreshAdjustedSentimentSubmitByConsumer &&
      //       state.filters.zipcode?.length === 0
      //     ) {
      //       setIsAdjustedPrediction(true);
      //       getAdjustedSentiment("consumer");
      //     }
      //   } else if (t == "Builder Sentiments(NAHB)") {
      //     if (
      //       state.filters.refreshAdjustedSentimentSubmitByBuilder &&
      //       state.filters.zipcode?.length === 0
      //     ) {
      //       setIsAdjustedPrediction(true);
      //       getAdjustedSentiment("builder");
      //     }
      //   }
      // });
    }
    else if(state.filters.showAnticipatedGrowth && state.filters.zipcode?.length === 0){
      setIsAdjustedPrediction(true);
      getAnticipatedGrowth()
    }
    
    else {
      setIsAdjustedPrediction(false)
      if (state.filters.showInterval && state.filters.zipcode?.length === 0) {
        getDaysOnMarketByInterval();
      } else if (state.filters.zipcode?.length && state.filters.showInterval) {
        getDaysOnMarketZipcodeByInterval();
      } 
      else if (state.filters.showComparison && state.filters.zipcode?.length ) {
        getDaysOnMarketByZipComparison(); 
      }
      else if (state.filters.zipcode?.length && !state.filters.showInterval) {
        getDaysOnMarketByZip();
      } 
      else if (state.filters.showComparison && state.filters.zipcode?.length === 0 ) {
        getDaysOnMarketComparison();
        
      }else {
        getDaysOnMarketByCounty();
      }
    }
  }, [
    state.filters.years,
    state.filters.county,
    state.filters.zipcode,
    state.filters.value,
    state.filters.showInterval,
    state?.filters?.selectedType,
    state?.filters?.regionType,
    state?.filters?.neighborhood,
    state.filters.refreshAdjustedPredictionSubmit ,
    state.filters.refreshAdjustedSentimentSubmitByConsumer,
    state.filters.refreshAdjustedSentimentSubmitByBuilder,
    state.filters.showComparison,
    state.filters.refreshAnticipatedPredictionSubmit ,
    state.filters.showAnticipatedGrowth
  ]);

  const getAllPredictionData=()=>{
    if (state.filters.predictionsArray.length != 0) {
      let mainarr: any = [];
      let res1: any = [];
      let res2: any = [];
      let res3: any = [];
    
      // Create an array of promises for each async call
      const promises = state.filters.predictionsArray.map(async (t: any) => {
        if (t == "Mortgage Rates") {
          const query = `${state.filters.state}/${state.filters.city[0]}/city`;
          let data = state.filters.adjustedPredictionValues;
          delete data.status;
          res1 = await getAdjustedPredictionData(query, data, "dom");
          console.log(res1, 'resp1');
        } else if (t == "Consumer Sentiments(HPSI)") {
          let type = 'consumer';
          const query = `${state.filters.state}/${state.filters.city[0]}/city`;
          let data =
            type === "consumer"
              ? state.filters.adjustedSentimentValuesByConsumer
              : state.filters.adjustedSentimentValuesByBuilder;
          delete data.status;
          res2 = await getAdjustedSentimentData(query, data, `dom/${type}`);
          console.log(res2, 'resp2');
        } else if (t == "Builder Sentiments(NAHB)") {
          let type = 'builder';
          const query = `${state.filters.state}/${state.filters.city[0]}/city`;
          let data =
            type === "consumer"
              ? state.filters.adjustedSentimentValuesByConsumer
              : state.filters.adjustedSentimentValuesByBuilder;
          delete data.status;
          res3 = await getAdjustedSentimentData(query, data, `dom/${type}`);
          console.log(res3, 'resp3');
        }
      });
    
      // Wait for all promises to resolve
      Promise.all(promises)
      .then(() => {
        if(res1.length>0){
          res1.forEach((item: any, index: any) => {
            mainarr.push({
              date: item.date,
              actual_predictions: item.actual_predictions,
              adjusted_prediction: res1[index]?.adjusted_prediction || "",
              consumer_adjusted_prediction: res2[index]?.adjusted_prediction || "",
              builder_adjusted_prediction: res3[index]?.adjusted_prediction || "",
            });
          });

        }
        else if(res2.length>0){
          res2.forEach((item: any, index: any) => {
            mainarr.push({
              date: item.date,
              actual_predictions: item.actual_predictions,
              adjusted_prediction: res1[index]?.adjusted_prediction || "",
              consumer_adjusted_prediction: res2[index]?.adjusted_prediction || "",
              builder_adjusted_prediction: res3[index]?.adjusted_prediction || "",
            });
          });

        }
        else if(res3.length>0){
          res3.forEach((item: any, index: any) => {
            mainarr.push({
              date: item.date,
              actual_predictions: item.actual_predictions,
              adjusted_prediction: res1[index]?.adjusted_prediction || "",
              consumer_adjusted_prediction: res2[index]?.adjusted_prediction || "",
              builder_adjusted_prediction: res3[index]?.adjusted_prediction || "",
            });
          });

        }

        console.log(mainarr);
        setChartData(mainarr)
      })
      .catch((error) => {
        console.error('Error occurred:', error);
      });
    }
    

  }

  const getAnticipatedGrowth=async ()=>{
    let mainarr:any=[]
    let res=[]
    const query = `${state.filters.state}/${state.filters.city[0]}/city`;
    let data = state.filters.adjustedAnticipatedValues;
    delete data.status;
    res = await getAnticipatedPredictionData(query, data, "dom");
    if(res.length>0){
      res.forEach((item: any, index: any) => {
        mainarr.push({
          date: item.date,
          actual_predictions: item.actual_predictions,
          adjusted_prediction: res[index]?.adjusted_prediction || "",
        });
      });

    }
    console.log(mainarr);
    setChartData(mainarr)

  }

  const getAdjustedSentiment = async (type: string) => {
    const query = `${state.filters.state}/${state.filters.city[0]}/city`;
    let data =
      type === "consumer"
        ? state.filters.adjustedSentimentValuesByConsumer
        : state.filters.adjustedSentimentValuesByBuilder;
    delete data.status;
    const resp = await getAdjustedSentimentData(query, data, `dom/${type}`);
    console.log(chartData);

    if (chartData != null) {
      if (chartData[0].hasOwnProperty("value1")) {
        setChartData(resp);
      } else {
        const keys = Object.keys(resp[0]);
        console.log(chartData);
        chartData.forEach((mainItem: any) => {
          resp.forEach((newItem: any) => {
            if (mainItem.date === newItem.date) {
              mainItem[keys[keys.length - 1]] = newItem[keys[keys.length - 1]];
            }
          });
        });
        console.log(chartData);
        setChartData(chartData);
      }
    } else {
      // setChartData(resp);
      getAllPredictionData()
    }
  };

  const getAdjustedPrediction = async () => {
    const query = `${state.filters.state}/${state.filters.city[0]}/city`;
    let data = state.filters.adjustedPredictionValues;
    delete data.status;
    const resp = await getAdjustedPredictionData(query, data, "dom");
    console.log(chartData);
    if (chartData != null) {
      if (chartData[0].hasOwnProperty("value1")) {
        setChartData(resp);
      } else {
        const keys = Object.keys(resp[0]);
        console.log(chartData);
        chartData.forEach((mainItem: any) => {
          resp.forEach((newItem: any) => {
            if (mainItem.date === newItem.date) {
              mainItem[keys[keys.length - 1]] = newItem[keys[keys.length - 1]];
            }
          });
        });
        console.log(chartData);
        setChartData(chartData);
      }
    } else {
      // setChartData(resp);
      getAllPredictionData()
    }

    // setChartData(resp);
  };

  const getDaysOnMarketByCounty = async () => {
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const county = JSON.stringify(state.filters.county)
      .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
      .replaceAll('"', "'");
      const response = await axios.get(
        `${baseURL}getDomCounty?state=${state.filters.state}&county=${county}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const data = generateChartData(response.data?.cube);
      setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  };
 const getDaysOnMarketComparison = async () => {
   const start = state.filters.years[0];
   const end = state.filters.years[1];
   try {
     const city = JSON.stringify(state.filters.city)
     .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
     .replaceAll('"', "'");
     const response1 = await axios.get(
       `${baseURL}getDaysOnMarket?state=${state.filters.state}&city=${city}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
     );
     const response2 = await axios.get(
       `${baseURL}getDaysOnMarketComparision?state=${state.filters.state}&city=${city}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
     );
     console.log(response1,response2)
     const result = mergeCompareData(response1.data.cube[state.filters.city[0]], response2.data.cube[state.filters.city[0]],'daysOnMarket');
     console.log(result)
     setChartData(result)
     // const data = generateChartData(response.data?.cube, 'ppsf');
     // setChartData(data);
   } catch (error) {
     console.log("error", error);
   }
 };

  const getDaysOnMarketByZip = async () => {
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const zipcode = JSON.stringify(
        state.filters.zipcode.map((item: string) => item.split("_")[0])
      )
        .replace(/[\[\]']+/g, "")
        .replaceAll('"', "'");
      const response = await axios.get(
        `${baseURL}getDaysOnMarketZipcode?state=${state.filters.state}&zipcode=${zipcode}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const data = generateZipChartData(response.data?.cube);
      setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  };
  const getDaysOnMarketByZipComparison = async () => {
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const zipcode = JSON.stringify(
        state.filters.zipcode.map((item: string) => item.split("_")[0])
      )
        .replace(/[\[\]']+/g, "")
        .replaceAll('"', "'");
      const response1 = await axios.get(
        `${baseURL}getDaysOnMarketZipcode?state=${state.filters.state}&zipcode=${zipcode}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const response2 = await axios.get(
        `${baseURL}getDaysOnMarketZipcodeComparision?state=${state.filters.state}&zipcode=${zipcode}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const result = mergeCompareData(response1.data.cube[state.filters.zipcode[0]], response2.data.cube[state.filters.zipcode[0]],'daysOnMarket');
      setChartData(result)
      // const data = generateChartData(response.data?.cube, 'ppsf');
      // setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getDaysOnMarketZipcodeByInterval = async () => {
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const zipcode = JSON.stringify(
        state.filters.zipcode.map((item: string) => item.split("_")[0])
      )
        .replace(/[\[\]']+/g, "")
        .replaceAll('"', "'");
      const response = await axios.get(
        `${baseURL}getDaysOnMarketZipcodeInterval?state=${state.filters.state}&zipcode=${zipcode}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const data = generateIntervalChartData(response.data?.cube);
      setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getDaysOnMarketByInterval = async () => {
    const city = JSON.stringify(state.filters.city)
    .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
    .replaceAll('"', "'");
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const response = await axios.get(
        `${baseURL}getDaysOnMarketInterval?state=${state.filters.state}&city=${city}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const data = generateIntervalChartData(response.data?.cube);
      setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  };
  const generateChartData = (apiData: any) => {
    try {
      const start = state.filters.years[0];
      const end = state.filters.years[1];
      const totalMonths = generateMonthCount(start, end);
      const data: any = [];
      for (let i = 0; i < totalMonths; i++) {
        let value: any = {};
        for (let j = 0; j < state.filters?.county?.length; j++) {
          if (apiData[state.filters.county[j]]?.length) {
            value = {
              ...value,
              date: moment(apiData[state.filters.county[j]][i]?.date).format(
                "YYYY-MM-DD"
              ),
              [`value${j + 1}`]:
              apiData[state.filters.county[j]][i]?.daysonmarket,
            };
          } else {
            continue;
          }
        }
        Object.keys(value)?.length > 0 && data.push(value);
      }
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const generateZipChartData = (apiData: any) => {
    try {
      const start = state.filters.years[0];
      const end = state.filters.years[1];
      const totalMonths = generateMonthCount(start, end);
      const data: any = [];

      for (let i = 0; i < totalMonths; i++) {
        let value: any = {};
        for (let j = 0; j < state.filters?.zipcode?.length; j++) {
          if (apiData[state.filters.zipcode[j].split("_")[0]]?.length) {
            value = {
              ...value,
              date: moment(
                apiData[state.filters.zipcode[j].split("_")[0]][i]?.date
              ).format("YYYY-MM-DD"),
              [`value${j + 1}`]:
              apiData[state.filters.zipcode[j].split("_")[0]][i]
                ?.daysOnMarket,
            };
          } else {
            continue;
          }
        }
        Object.keys(value)?.length > 0 && data.push(value);
      }
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const generateIntervalChartData = (apiData: any) => {
    try {
      const data: any = apiData.map((item: any) => {
        return {
          date: moment(item?.date).format("YYYY-MM-DD"),
          value1: item?.daysOnMarketHigh,
          value2: item?.daysOnMarketLow,
          value3: item?.daysOnMarket,
        };
      });
      return data;
    } catch (error) {
      console.log(error);
    }
  };
  const getSelectValue=()=>{
    switch(state.filters.value){
      case 'Absolute':
        return 'Absolute'
      case 'growth':
          return ' Growth (Month on Month)'
      case 'trend':
            return 'Long Term Trend'
     case 'percentage':
              return 'Percentage'
      
    }
  }

  return (
    <div className="daysOnMarket-main prediction-chart">
      {chartData?.length && !isAdjustedPrediction ? (
        <div className="daysOnMarket-main__text">Days on market {getSelectValue()}</div>
      ) : null}
      <div className="daysOnMarket-main__chartContainer">
        {chartData === null ? (
          <div className="daysOnMarket-main__chartContainer__isLoading">
            <Bars height='400' ariaLabel='bars-loading' wrapperClass='tab-spinner-progress-bar' visible={true}/>
          </div>
        ) : chartData?.length ? (
          <>
            {isAdjustedPrediction ? (
              <WChart
                chartData={chartData}
                chartId={'dom-chart'}
                title='Adjusted DOM Projection  '
                isMulti
                isPredition
                isSetToZoom
              />
            ) : (
              <Chart
                chartData={chartData}
                title={`Days on market ${state.filters.value === 'growth' ? '(% Growth (Month on Month))': ''}`}
                city={state.filters.city}
                county={state.filters.county}
                zipcode={state.filters.zipcode}
                showInterval={state.filters.showInterval}
              />
            )}

          </>

        ) : (
          <div className="daysOnMarket-main__chartContainer__noData">
            No Data Available
          </div>
        )}
      </div>
    </div>
  );
};

export default DaysOnMarket;
